import React, {FC} from 'react';

import {Box, DialogContent, Typography} from '@mui/material';
import {t} from 'i18next';

import {BasketDialogTitle} from './BasketDialogTitle';
import {StyledDialog, StyledBottomSheet} from './styles';

export interface DeliveryDetailsPreOrderModalProps {
  open: boolean;
  deliveryBy: string;
  onClose: () => void;
  isReactNativeWebView: boolean;
}

export const DeliveryDetailsPreOrderModal: FC<DeliveryDetailsPreOrderModalProps> = ({
  open,
  onClose,
  deliveryBy,
  isReactNativeWebView
}) => {
  const sellerName = t('sellerDelivery.preOrder.sellerName');
  const ModalContainer = isReactNativeWebView ? StyledBottomSheet : StyledDialog;
  return (
    <ModalContainer className="pre-order-delivery-modal" open={open} onClose={onClose} anchor="bottom">
      <BasketDialogTitle title={t('sellerDelivery.preOrder.title')} onClose={onClose} />
      <DialogContent>
        <Box>
          <Typography
            dangerouslySetInnerHTML={{
              __html: t('sellerDelivery.preOrder.deliveredBy', {
                sellerName,
                deliveryBy
              })
            }}
          />
        </Box>
      </DialogContent>
    </ModalContainer>
  );
};

DeliveryDetailsPreOrderModal.displayName = 'DeliveryDetailsPreOrderModal';
